import { GridId } from 'store/grid'
import { ClearingGridColumnId, CollectionColumnId } from 'view/routes/ColumnNames'
import { DealsGridColumnId } from 'view/routes/deals/components/DealsGridColumnNames'
import { LiveGridColumnId } from 'view/routes/requests/LiveNegotiationsGrid/LiveGridColumnNames'

export const DefaultIncomingCopyColumnIds: string[] = [
  LiveGridColumnId.COUNTERPARTY_NAME,
  LiveGridColumnId.NEGOTIATION_DIRECTION,
  LiveGridColumnId.COLLATERAL_NAME,
  LiveGridColumnId.COLLATERAL_ISIN_OR_BUI,
  LiveGridColumnId.COLLATERAL_CUSIP,
  LiveGridColumnId.NEGOTIATION_NOTIONAL,
  LiveGridColumnId.NEGOTIATION_START_DATE,
  LiveGridColumnId.NEGOTIATION_START_DATE_TARGET,
  LiveGridColumnId.START_DATE_DELTA,
  LiveGridColumnId.NEGOTIATION_END_DATE,
  LiveGridColumnId.NEGOTIATION_END_DATE_TARGET,
  LiveGridColumnId.END_DATE_DELTA,
  LiveGridColumnId.NEGOTIATION_RATE,
  LiveGridColumnId.NEGOTIATION_RATE_TARGET,
  LiveGridColumnId.NEGOTIATION_LAST_QUOTED,
  LiveGridColumnId.NEGOTIATION_HAIRCUT,
  LiveGridColumnId.NEGOTIATION_HAIRCUT_TARGET,
  LiveGridColumnId.HAIRCUT_DELTA,
  LiveGridColumnId.NEGOTIATION_START_CONSIDERATION,
  LiveGridColumnId.NEGOTIATION_START_CONSIDERATION_ORIGINAL,
  LiveGridColumnId.START_CONSIDERATION_DELTA,
  LiveGridColumnId.NEGOTIATION_AXE_ROLL_UNWIND,
  LiveGridColumnId.NEGOTIATION_RFQ_TYPE,
  LiveGridColumnId.NEGOTIATION_CALLABLE,
  LiveGridColumnId.NEGOTIATION_ORDER_ID
]

export const DefaultCurveCopyColumnIds: string[] = [
  LiveGridColumnId.COUNTERPARTY_NAME,
  CollectionColumnId.COLLECTION_ID,
  LiveGridColumnId.COLLATERAL_NAME,
  LiveGridColumnId.COLLATERAL_ISIN_OR_BUI,
  LiveGridColumnId.NEGOTIATION_DIRECTION,
  LiveGridColumnId.NEGOTIATION_NOTIONAL,
  LiveGridColumnId.NEGOTIATION_CALLABLE,
  LiveGridColumnId.NEGOTIATION_CALL_DAYS,
  LiveGridColumnId.REFERENCE_RATE_NAME,
  ClearingGridColumnId.COUNTERPARTY_CLEARING
]

export const DefaultDealsCopyColumnIds: string[] = [
  DealsGridColumnId.COUNTERPARTY_NAME,
  DealsGridColumnId.FUND_NAME,
  DealsGridColumnId.COLLATERAL_NAME,
  DealsGridColumnId.COLLATERAL_ISIN_OR_BUI,
  DealsGridColumnId.DEAL_BOND_PRICE,
  DealsGridColumnId.DEAL_DIRECTION,
  DealsGridColumnId.DEAL_TERM,
  DealsGridColumnId.DEAL_START_DATE,
  DealsGridColumnId.DEAL_END_DATE,
  DealsGridColumnId.DEAL_NOTIONAL,
  DealsGridColumnId.DEAL_START_CONSIDERATION,
  DealsGridColumnId.DEAL_RATE,
  DealsGridColumnId.DEAL_HAIRCUT,
  DealsGridColumnId.DEAL_HAIRCUT_TYPE
]

export const DefaultColsByGridId: Partial<Record<GridId, string[]>> = {
  [GridId.IncomingGrid]: DefaultIncomingCopyColumnIds,
  [GridId.CurvesGrid]: DefaultCurveCopyColumnIds,
  [GridId.DealsGrid]: DefaultDealsCopyColumnIds
}
